import React from 'react';
import Tool, {
  type ToolArgsWithController,
  type ToolArgs,
} from '../../../tools/Tool';
import { normalizeHref, displayURL } from '../../LinkPlugin/utils';
import { isLinkCardElement } from '../../../types/guards';
import type { Placement } from '@floating-ui/dom';
import { Editor } from 'slate';

// Open hyperlink card.
class ToolOpenLinkCard extends Tool {
  static toolName = 'Open link card';
  static iconClass = 'fa-regular fa-arrow-up-right-from-square';

  static renderToolbarButtonIcon({ element }: ToolArgs): JSX.Element {
    let displayUrl = '';
    if (
      element &&
      isLinkCardElement(element) &&
      element.linkCard_href &&
      element.linkCard_href.length > 4
    ) {
      // Simplify the URL a little for display
      displayUrl = displayURL(element.linkCard_href);
    }
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 'var(--spacer-1)',
        }}
      >
        {displayUrl && (
          <span
            style={{
              maxWidth: 200,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {displayUrl}
          </span>
        )}
        <i className="fa-regular fa-arrow-up-right-from-square" />
      </div>
    );
  }

  static action({ element }: ToolArgs): void {
    if (!element || !isLinkCardElement(element)) return;

    try {
      if (element.linkCard_href) {
        const newWindow = window.open(
          normalizeHref(element.linkCard_href),
          '_blank'
        );

        // window.open could have failed because of popup blockers, etc.
        if (newWindow) {
          newWindow.focus();
        }
      }
    } catch (e) {
      console.log('Error opening link card URL', e);
    }
  }

  static isEnabled({ element }: ToolArgs): boolean {
    return Boolean(
      element &&
        isLinkCardElement(element) &&
        element.linkCard_href &&
        element.linkCard_href !== '#'
    );
  }

  static available({ editor, element }: ToolArgsWithController): boolean {
    // Get the selected element from the editor
    if (!editor?.selection) return false;

    return Boolean(
      Editor.above(editor, {
        mode: 'lowest',
        match: (n) => {
          return Boolean(
            isLinkCardElement(n) &&
              n.linkCard_href &&
              n.linkCard_href.trim() !== '' &&
              n.linkCard_href !== '#'
          );
        },
      })
    );
  }

  static tooltipPlacement(): Placement {
    return 'bottom';
  }
}

export default ToolOpenLinkCard;
